import React, { useRef, useState, useCallback } from "react";

const DEFAULT_TILT = 6;

export default function Tilt3D({
  children,
  maxTilt = DEFAULT_TILT,
  scale = 1.012,
  glare = true,
  radius = 22,
  style,
  className,
  onClick,
  role,
  ariaLabel,
}) {
  const ref = useRef(null);
  const [transform, setTransform] = useState("perspective(1000px) rotateX(0deg) rotateY(0deg) scale(1)");
  const [glarePos, setGlarePos] = useState({ x: 50, y: 0, opacity: 0 });

  const onMove = useCallback((e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const px = (e.clientX - rect.left) / rect.width;
    const py = (e.clientY - rect.top) / rect.height;
    const ry = (px - 0.5) * 2 * maxTilt;
    const rx = -(py - 0.5) * 2 * maxTilt;
    setTransform(`perspective(1000px) rotateX(${rx.toFixed(2)}deg) rotateY(${ry.toFixed(2)}deg) scale(${scale})`);
    setGlarePos({ x: px * 100, y: py * 100, opacity: 0.18 });
  }, [maxTilt, scale]);

  const onLeave = useCallback(() => {
    setTransform("perspective(1000px) rotateX(0deg) rotateY(0deg) scale(1)");
    setGlarePos((g) => ({ ...g, opacity: 0 }));
  }, []);

  return (
    <div
      ref={ref}
      className={className}
      role={role}
      aria-label={ariaLabel}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      onClick={onClick}
      style={{
        position: "relative",
        transform,
        transformStyle: "preserve-3d",
        transition: "transform 240ms cubic-bezier(0.2, 0.8, 0.2, 1)",
        willChange: "transform",
        borderRadius: radius,
        cursor: onClick ? "pointer" : "default",
        ...style,
      }}
    >
      {children}
      {glare ? (
        <div
          aria-hidden
          style={{
            position: "absolute",
            inset: 0,
            borderRadius: radius,
            pointerEvents: "none",
            background: `radial-gradient(circle at ${glarePos.x}% ${glarePos.y}%, rgba(255,255,255,0.85) 0%, rgba(255,255,255,0) 45%)`,
            mixBlendMode: "overlay",
            opacity: glarePos.opacity,
            transition: "opacity 240ms ease",
          }}
        />
      ) : null}
    </div>
  );
}
